/**
 * Footer block accordion for mobile/tablet. Collapse animation is CSS-driven.
 */
class FooterBlock extends HTMLElement {
  constructor() {
    super();
    this.isMobile = new DeviceWidth().isMobile;
    this.isiPadPro = window.matchMedia(
      'only screen and (min-width: 1024px) and (max-height: 1366px) and (-webkit-min-device-pixel-ratio: 1.5) and (hover: none)'
    ).matches;
    this.titleSelector = '.accordion-title';
  }

  connectedCallback() {
    if (!this.isMobile && !this.isiPadPro) return;

    const title = this.querySelector(this.titleSelector);
    if (!title) return;

    if (!this._clickHandler) {
      this._clickHandler = () => this.toggleOpenState();
      title.addEventListener('click', this._clickHandler);
    }
  }

  disconnectedCallback() {
    const title = this.querySelector(this.titleSelector);
    title?.removeEventListener('click', this._clickHandler);
    this._clickHandler = null;
  }

  /**
   * Toggles this footer block and closes other open footer blocks.
   */
  toggleOpenState() {
    if (this.hasAttribute('open')) {
      this.removeAttribute('open');
      return;
    }

    document.querySelectorAll('footer-block').forEach((element) => {
      if (element !== this && element.hasAttribute('open')) {
        element.removeAttribute('open');
      }
    });

    this.setAttribute('open', '');
  }
}

if (!customElements.get('footer-block')) {
  customElements.define('footer-block', FooterBlock);
}
